import { createComponent } from '@lit/react';
import React from 'react';
import { SDSCheckboxGroup } from '../sds-checkbox-group/sds-checkbox-group';
import { SheriffEventName } from './types';

export const SDSCheckboxGroupWrapper = createComponent({
	tagName: 'sds-checkbox-group',
	elementClass: SDSCheckboxGroup,
	react: React,
	events: {
		onUpdate: 'sds-update' as SheriffEventName,
		onChange: 'change' as SheriffEventName,
	},
});
